import { Controller } from "@hotwired/stimulus"
import pageMessageBroker from "../page_message_broker"

// Connects to data-controller="plan-design-modal-trigger"
export default class extends Controller {
  static values = {
    rtqId: String,
    marketingId: String,
    clientId: String,
    excludeIds: String
  }

  connect() {
    console.log("PlanDesignModalTriggerController connected")
  }

  open() {
    console.log("Dispatching open-plan-design-modal event")
    pageMessageBroker.dispatch("open-plan-design-modal", {
      rtqId: this.rtqIdValue,
      marketingId: this.marketingIdValue,
      clientId: this.clientIdValue,
      excludeIds: this.excludeIdsValue
    })
  }
}
